module.exports = ['$scope', '$translate', function ($scope, $translate) {
    $scope.selectedLang = $scope.languages ? $scope.languages[0] : {};
    $scope.switchLanguage = function (langCode) {
        $scope.selectedLang = langCode;
        $translate.use(langCode.code);
    };
}];



//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-core/directives/languageSwitch/languageSwitchCtrl.js
// module id = 316
// module chunks = 0